// TEMPORARY (temp/linked-customer): calls to the /linked-customer routes. Same files as admin_frontend except BASE and the OTP url; staff has no Retry/Resync (isAdmin stays false, the backend has no such routes). basePath = "/staff/linked-customer".
import { useEffect, useState } from "react";
import Handler from "../../Helpers/Handler";

export const BASE = "/staff/linked-customer";
const out = (r) => ({ ok: !!r?.success, message: r?.data?.message || "", data: r?.data?.data });

export const linkedApi = (base = BASE) => ({
    config: async () => out(await Handler({ method: "get", url: `${base}/config`, silent: true })),
    get: async (id) => out(await Handler({ method: "get", url: `${base}/${id}`, silent: true })),
    status: async (ids) => out(await Handler({ method: "post", url: `${base}/status`, data: { customerIds: ids }, silent: true })),
    link: async (id) => out(await Handler({ method: "post", url: `${base}/${id}/link`, data: {} })),
    confirm: async (id, confirmCustomerId) => out(await Handler({ method: "post", url: `${base}/${id}/confirm-existing`, data: { confirmCustomerId } })),
    retry: async (id) => out(await Handler({ method: "post", url: `${base}/${id}/retry`, data: {} })),
    resync: async (id) => out(await Handler({ method: "post", url: `${base}/${id}/resync`, data: {} })),
    phones: async (id) => out(await Handler({ method: "get", url: `${base}/${id}/phones` })),
    phoneOtp: async (id, slot) => out(await Handler({ method: "post", url: `${base}/${id}/phone/otp`, data: slot })),
    phoneVerify: async (id, slot, otp) => out(await Handler({ method: "patch", url: `${base}/${id}/phone/verify`, data: { ...slot, otp } })),
    verifyRegistration: async (phone, otp) => out(await Handler({ method: "post", url: `${base}/registration/verify-otp`, data: { phone, otp } }))
});

// Is the feature switched on? Asked once per page load; false while the answer is unknown or the call fails.
let cached = null;
export const useLinkedEnabled = (base = BASE) => {
    const [enabled, setEnabled] = useState(cached?.[base] ?? false);
    useEffect(() => {
        if (cached?.[base] !== undefined) return undefined;
        let alive = true;
        linkedApi(base).config().then((r) => {
            const v = !!(r.ok && r.data?.enabled);
            cached = { ...(cached || {}), [base]: v };
            if (alive) setEnabled(v);
        });
        return () => { alive = false; };
    }, [base]);
    return enabled;
};
